import { memo } from 'react';
import { previewPicture } from '@/sub-luca-plugin/utils';

interface IProps {
    content: string;
}

const TeacherReply = ({ content }: IProps) => {
    const handleClick = (ev: any) => {
        if (ev.target.nodeName !== 'IMG') return;
        previewPicture(ev.target.src);
    };

    return (
        <div className="respondent-container">
            <div className="respondent__teacher-reply">
                <div className="respondent__rich-text" dangerouslySetInnerHTML={{ __html: content }} onClick={handleClick}></div>
            </div>
        </div>
    );
};

export default memo(TeacherReply);
